import "core-js/modules/es.array.reduce";
import _regeneratorRuntime from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { needs } from '@aws-crypto/material-management';
export function getClient(KMSClient, defaultConfig) {
  return function getKmsClient(region) {
    /* a KMS alias is supported.  These do not have a region
     * in this case, the Encryption SDK should find the default region
     * or the default region needs to be supplied to this function
     */
    var config = region ? _objectSpread(_objectSpread({}, defaultConfig), {}, {
      region: region
    }) : _objectSpread({}, defaultConfig);
    var client = new KMSClient(config);
    /* Postcondition: A region must be configured.
     * The AWS SDK has a process for determining the default region.
     * A user can configure a default region by setting it in `defaultConfig`
     * But KMS requires a region to operate.
     */
    // @ts-ignore the V3 client has set the config to protected, reasonable, but I need to know...

    needs(client.config.region, 'A region is required');
    return client;
  };
}
export function limitRegions(regions, getClient) {
  /* Precondition: limitRegions requires that region be a string. */
  needs(regions.every(function (r) {
    return !!r && typeof r === 'string';
  }), 'Can only limit on region strings');
  return function (region) {
    if (!regions.includes(region)) return false;
    return getClient(region);
  };
}
export function excludeRegions(regions, getClient) {
  /* Precondition: excludeRegions requires region be a string. */
  needs(regions.every(function (r) {
    return !!r && typeof r === 'string';
  }), 'Can only exclude on region strings');
  return function (region) {
    if (regions.includes(region)) return false;
    return getClient(region);
  };
}
export function cacheClients(getClient) {
  var clientsCache = {};
  return function (region) {
    // Do not cache until KMS has been responded in the given region
    if (!Object.prototype.hasOwnProperty.call(clientsCache, region)) return deferCache(clientsCache, region, getClient(region));
    return clientsCache[region];
  };
}
/* It is possible that a malicious user can attempt a local resource
 * DOS by sending ciphertext with a large number of spurious regions.
 * This will fill the cache with regions and exhaust resources.
 * To avoid this, a call succeeds in contacting KMS.
 * This does *not* mean that this call is successful,
 * only that the region is backed by a functional KMS service.
 */

export function deferCache(clientsCache, region, client) {
  /* Check for early return (Postcondition): No client, then I cache false and move on. */
  if (!client) {
    clientsCache[region] = false;
    return false;
  }

  var encrypt = client.encrypt,
      decrypt = client.decrypt,
      generateDataKey = client.generateDataKey;
  return ['encrypt', 'decrypt', 'generateDataKey'].reduce(wrapOperation, client);
  /* Wrap each of the operations to cache the client on response */

  function wrapOperation(client, name) {
    var original = client[name];

    client[name] = /*#__PURE__*/function () {
      var _wrappedOperation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args) {
        var v2vsV3Response, v2vsV3Promise;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // @ts-ignore (there should be a TypeScript solution for this)
                v2vsV3Response = original.call(client, args);
                v2vsV3Promise = 'promise' in v2vsV3Response ? v2vsV3Response.promise() : v2vsV3Response;
                return _context2.abrupt("return", v2vsV3Promise.then(function (response) {
                  clientsCache[region] = Object.assign(client, {
                    encrypt: encrypt,
                    decrypt: decrypt,
                    generateDataKey: generateDataKey
                  });
                  return response;
                }).catch( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            /* Errors from a KMS contact mean that the region is "live".
                             * As such the client can be cached because the problem is not with the client per se,
                             * but with the request made.
                             */
                            if (e.$metadata && e.$metadata.httpStatusCode) {
                              clientsCache[region] = Object.assign(client, {
                                encrypt: encrypt,
                                decrypt: decrypt,
                                generateDataKey: generateDataKey
                              });
                            } // The request was not successful


                            return _context.abrupt("return", Promise.reject(e));

                          case 2:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function wrappedOperation(_x) {
        return _wrappedOperation.apply(this, arguments);
      }

      return wrappedOperation;
    }();

    return client;
  }
}